import axios from 'axios';

import { PaginatedResponse } from 'api/api.model';
import { apiEndpoints } from 'apiEndpoints';

import {
  USER_TYPE,
  UserAddViewModel,
  UserGetListViewModel,
  UserGetViewModel,
  UserModifyViewModel,
} from './users.model';

// TODO filters, also probably wont be used
const getUsers = async (): Promise<PaginatedResponse<UserGetListViewModel>> => {
  const response = await axios.get(apiEndpoints.users.index);
  return response.data;
};

// TODO probably wont be used
const postUsers = async (userData: UserAddViewModel): Promise<void> => {
  const response = await axios.post(apiEndpoints.users.index, userData);
  return response.data;
};

// http 500 jesli id to  numer
const getUsersID = async (id: string): Promise<UserGetViewModel> => {
  const response = await axios.get(apiEndpoints.users.index, { params: { id: id } });
  return response.data;
};

// TODO probably wont be used
const patchUsersID = async (id: string, user: UserModifyViewModel): Promise<void> => {
  const response = await axios.patch(apiEndpoints.users.index, { id: id, user: user });
  return response.data;
};

// TODO probably wont be used
const getUsersNotification = async (type: USER_TYPE, userId: string): Promise<void> => {
  const response = await axios.get(apiEndpoints.users.index, {
    params: { type: type, userId: userId },
  });
  return response.data;
};

/* missing: 
patchUsersPassword, 
getResetPassword
*/

const users = {
  getUsers,
  postUsers,
  getUsersID,
  patchUsersID,
  getUsersNotification,
};

export default users;
